import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import styles from "./CommunicationTimeline.module.css";
import { CommunicationTimelineEntry } from "./CommunicationTimelineEntry";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import { COMMUNICATION_TIMELINE_ENTRY } from "src/stores/CommunicationStore";

const CommunicationTimelineBase = () => {
    const { communicationStore, navStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    if (communicationStore.isCommunicationStoreInitializing) {
        return (
            <div>
                <UI.RotatingSpinner noLogo size={50} />
            </div>
        );
    }

    if (communicationStore.communicationEntries?.length === 0) {
        return <div>{t("screens.assemblies.communicationcontent.error.no_communication_entries_available")}</div>;
    }

    return (
        <div className={styles.TimelineContainer}>
            {communicationStore.communicationEntries.map((entry, index) =>
                entry.state === COMMUNICATION_TIMELINE_ENTRY.PROTOCOL_PUBLISHED &&
                !navStore.hasFeatureFlagAssembly ? null : (
                    <CommunicationTimelineEntry key={entry.state || index} entry={entry} />
                )
            )}
        </div>
    );
};

export const CommunicationTimeline = Sentry.withProfiler(observer(CommunicationTimelineBase));
